import { format } from 'date-fns';
import { formatCurrency } from '@/components/common/Currency';
import { parseDateOnly } from '@/utils/dateUtils';

// Display formatters shared by the AR report pages and the statement send
// dialog (extracted from the reports page's ar-report-shared.tsx when the
// dialog moved into components/).

export function formatDecimalCurrency(
  value: string | null | undefined,
): string {
  const num = parseFloat(value ?? '0');
  return formatCurrency(num, { currency: 'USD' });
}

export function formatDate(dateString: string | null): string {
  if (!dateString) return '—';
  const date = parseDateOnly(dateString);
  if (!date) return dateString;
  return format(date, 'MM/dd/yyyy');
}
